<template>
  <div>
    <el-button type="primary" @click="dialogVisible = true"
      >查看员工奖励总额</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="查看员工奖励总额"
      width="1200px"
      @close="closeDialog"
    >
      <el-table :data="StaffSumLists">
        <el-table-column prop="userId" label="员工id"></el-table-column>

        <el-table-column prop="coinType" label="币种"></el-table-column>

        <el-table-column prop="amount" label="金额"></el-table-column>

        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.balanceChangeStatus == 0"
              >奖励总冻结转账任务创建</span
            >
            <span v-else-if="scope.row.balanceChangeStatus == 1"
              >奖励总冻结转账任务执行成功</span
            >
            <span v-else-if="scope.row.balanceChangeStatus == -1"
              >奖励总冻结转账任务执行失败</span
            >
            <span v-else-if="scope.row.balanceChangeStatus == -2"
              >奖励总冻结转账任务执行超时</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import '../../store';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'kpiCreate',
  data() {
    return {
      dialogVisible: false,
      detail: {
        userId: '',
        coinType: 'FBS',
        amount: ''
      },
      options: [
        {
          value: '0',
          label: 'PC和APP'
        },
        {
          value: '1',
          label: 'PC'
        },
        {
          value: '2',
          label: 'APP'
        }
      ],
      types: [
        { value: '0', label: '普通抢购项目' },
        { value: '1', label: '新人专场' }
      ],
      rules: {
        userId: {
          required: true,
          message: '请填写'
        },
        coinType: {
          required: true,
          message: '请填写'
        },
        amount: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  components: {},
  computed: {
    ...mapState('kpiProject', ['coinTypeList', 'languageList', 'StaffSumLists'])
  },
  created() {
    this.getStaffSumList();
  },
  methods: {
    ...mapActions('kpiProject', ['add', 'getStaffSumList']),

    closeDialog() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
